import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OutputTablesComponent } from './output-tables.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../layout/layout.module';
import { MdbModule } from '../mdb/mdb.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { ModalsModule } from '../modals/modals.module';

@NgModule({
  declarations: [OutputTablesComponent],
  imports: [
    CommonModule,
    RouterModule,
    AppRoutingModule,
    MdbModalModule,
    ModalsModule,
    LayoutModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MdbModule,
  ],
})
export class OutputTablesModule {}
